import { i18n } from "@dehub/theme";
import { message, translateIfKey } from "./Message";

export function handleError(error: unknown, fallback?: string) {
  const err = error as { message?: string | { message?: string } };
  const nested = typeof err?.message === "object" ? err.message?.message : undefined;
  const flat = typeof err?.message === "string" ? err.message : undefined;
  message.error(nested || flat || fallback || i18n.t("common:actionFailed"));
}

/** The user-facing text of an API error, for summaries that list several failures. */
export function errorReason(error: unknown): string {
  const err = error as { message?: string | { message?: string } };
  const raw = typeof err?.message === "object" ? err.message?.message : err?.message;
  return raw ? translateIfKey(raw) : i18n.t("common:actionFailed");
}
